import { BENEFITS } from "../content/site";
import { Reveal, SectionHeading } from "./Reveal";

export const Benefits = () => (
  <section id="why" data-testid="benefits-section" className="relative py-24 lg:py-32 bg-[#FAFAFA] border-y border-slate-100">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-[1fr_1.2fr] gap-16">
      <div className="lg:sticky lg:top-32 self-start">
        <Reveal>
          <SectionHeading
            overline="Why WebStudios"
            title="Your website. Taken care of."
            sub="Most business owners don't want to think about hosting, updates or security — and with WebStudios, you never have to. One team handles everything, so you can focus on running your business."
          />
          <a href="#contact" data-testid="benefits-cta"
            className="mt-8 inline-flex items-center gap-2 bg-[#0055FF] hover:bg-[#0044CC] text-white font-semibold px-7 py-3.5 rounded-full transition-colors duration-200 glow-blue">
            Hand it over to us
          </a>
        </Reveal>
      </div>
      <div>
        {BENEFITS.map((b, i) => {
          const num = String(i + 1).padStart(2, "0");
          return (
            <Reveal key={b.title} delay={0.04 * i}>
              <div className="group relative py-9 border-b border-slate-200 first:border-t flex gap-6 sm:gap-10 items-start transition-[padding] duration-500 hover:pl-3" data-testid={`benefit-item-${i}`}>
                <span aria-hidden="true" className="font-display text-6xl lg:text-8xl font-semibold leading-none select-none text-transparent transition-opacity duration-500"
                  style={{ WebkitTextStroke: "1px rgba(15,23,42,0.16)" }}>
                  {num}
                </span>
                <div className="pt-1">
                  <p className="font-mono2 text-[10px] tracking-[0.3em] uppercase text-cyan-600 mb-2">Chapter {num}</p>
                  <h3 className="font-display text-2xl lg:text-3xl font-semibold text-slate-900 tracking-tight transition-colors duration-300 group-hover:text-[#0055FF]">{b.title}</h3>
                  <p className="mt-2 text-sm lg:text-base text-slate-600 leading-relaxed max-w-lg">{b.desc}</p>
                </div>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
